import { useEffect, useState } from 'react';
import type { IProduct } from '@recargas-dominicanas/core/types';
import { useProducts, useTransactions } from '@recargas-dominicanas/core/store';
import { Title } from '@recargas-dominicanas/core/components';
import { TransactionsCard } from '../../components/transactions-card/transactions-card.component';
import { DataPlan } from '../../components/data-plan/data-plan.component';
import { Products } from '../../components/products/products.component';
import { Invoice } from '../../components/invoice/invoice.component';
import { Insurance } from '../../components/insurance/insurance.component';
import { Pin } from '../../components/pin/pin.component';
import { Balance } from '../../components/balance/balance.component';
import { Topup } from '../../components/topup/topup.component';
import { style } from './home.module.css';
import { SearchBar } from '../../components/search-bar/search-bar.component';

export function Home() {

  const productsStore = useProducts();
  const transactionStore = useTransactions();
  const products = productsStore.get();
  const [product, setProduct] = useState<IProduct>(products[0]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    transactionStore.fetchGroupByDay(1, 50);
  }, []);

  function handleProductClick(product: IProduct) {
    setProduct(product);
  }

  return (
    <div className={style.container}>
      <div className={style.toolbar}>
        <Title style={style.title} title='Recargas'/>
        <SearchBar
          value={search} 
          onChange={setSearch}/>
        <div className={style.options}>
          <Balance/>
        </div>
      </div>
      <div className={style.content}>
        <TransactionsCard/>
        <Products
          search={search} 
          onClick={handleProductClick}
          onClearSearch={() => setSearch('')}/>
        {product.type === 'Recarga' && <Topup product={product}/>}
        {product.type === 'Paquetico' && <DataPlan product={product}/>}
        {product.type === 'Pin' && <Pin product={product}/>}
        {product.type === 'Factura' && <Invoice product={product}/>}
        {product.type === 'Seguro' && <Insurance product={product}/>}
      </div>
    </div>
  );
}
